import { IComparableSearchArgsGQL, IComparablesTransaction, ISortQuery } from "react-migration/lib/typings/comparables";
import { useHometrackValue } from "./useHometrackValue";
import { PriceSquare } from "./PriceSquare";
import { HometrackRentalDisplayBy } from "./HometrackLayerFilters";
import { filterToRentalParams } from "./utils";

export const HometrackValuesRental = ({
  searchCriteria,
  sortCriteria,
  displayBy,
}: {
  searchCriteria: IComparableSearchArgsGQL;
  sortCriteria: ISortQuery<IComparablesTransaction>;
  displayBy: HometrackRentalDisplayBy;
}) => {
  const [filter, priceMode] = filterToRentalParams[displayBy];
  // We fetch multiple times here as each result maxes out at 200 results, so to ensure
  // we get the best accuracy, we fetch each filter separately to ensure we get the most
  // relevant results for each average
  const {
    value: detachedValue,
    valueArea: detachedValueArea,
    loading: detachedValueLoading,
  } = useHometrackValue({ ...searchCriteria, ...filter, propertyType: "Detached" }, sortCriteria, priceMode);

  const {
    value: semiDetachedValue,
    valueArea: semiDetachedValueArea,
    loading: semiDetachedValueLoading,
  } = useHometrackValue(
    {
      ...searchCriteria,
      ...filter,
      propertyType: "Semi_Detached",
    },
    sortCriteria,
    priceMode
  );

  // Terraced and flats
  const {
    value: terracedValue,
    valueArea: terracedValueArea,
    loading: terracedValueLoading,
  } = useHometrackValue(
    {
      ...searchCriteria,
      ...filter,
      propertyType: "Terraced",
    },
    sortCriteria,
    priceMode
  );

  const {
    value: flatValue,
    valueArea: flatValueArea,
    loading: flatValueLoading,
  } = useHometrackValue(
    {
      ...searchCriteria,
      ...filter,
      propertyType: "Flat_Maisonette",
    },
    sortCriteria,
    priceMode
  );

  return (
    <div className="grid grid-cols-2 gap-2">
      <PriceSquare title="Detached" price={detachedValue} area={detachedValueArea} loading={detachedValueLoading} />
      <PriceSquare
        title="Semi-detached"
        price={semiDetachedValue}
        area={semiDetachedValueArea}
        loading={semiDetachedValueLoading}
      />
      <PriceSquare title="Terraced" price={terracedValue} area={terracedValueArea} loading={terracedValueLoading} />
      <PriceSquare title="Flat/Maisonette" price={flatValue} area={flatValueArea} loading={flatValueLoading} />
    </div>
  );
};
